import { type ComponentType } from 'react';
import type { TimelineSlot, TimelineSlotType } from '../types';
import { CapacityCard } from './CapacityCard';
import { SurgeryCard } from './SurgeryCard';
import { TurnoverCard } from './TurnoverCard';

export const Cards: Record<TimelineSlotType, ComponentType<TimelineSlot>> = {
  surgery: SurgeryCard as ComponentType<TimelineSlot>,
  turnover: TurnoverCard as ComponentType<TimelineSlot>,
  capacity: CapacityCard as ComponentType<TimelineSlot>,
};
